module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAASJJREFUSEvtlE1uwjAQhf3gGF31MFwDp0CCKpR0hwQbWCEWSBV/m6StQluJM3AZlhwCgadKIDQJNnYW2SCyszJ+n9/zeMBK/lCyPnsAtAnfUUTTIOyAqM8Ia9fhXQBC6z9VQESY+d8jQNRBmLht6z36fYlo5odbIno+7cGv53BuConE50H4QcQa8W6wnee8PGUA82A1EEIM/w9lBsmLn/ZXxm9t3ssA4kJ/tSRGr6YQqTjw6dncBkAZQLQoAjERvwKYQmTiAPtybauVnDxJQfoObjmJjKYv9HypUnGpg4SsggC0T7pFJ34ToI4r1QKKWNLvRzsq5E7iXlfGUgggc2Iqro0oPyoWwU/tiEPVa1qbfLeoxoo2oiLzSFb7AGgTLD2iP6p6xhkp25kzAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product-detail/icon-arrow-down.png
// module id = jYEJ
// module chunks = 4